<template>
    <div v-if="currentDangerActive">
      <el-select
        v-model="activeTab"
        filterable
        class="mb-2 b-select-modules"
      >
        <el-option
          v-for="(field, index) in currentDangerActive.danger_fields"
          :key="index"
          :label="field.label"
          :value="index"
        />
      </el-select>
      <b-tabs v-model="activeTab" class="b-tabs-sp" active-nav-item-class="border-info text-dark bg-light p-relative" pills vertical>
        <b-tab no-key-nav lazy :title="field.label" v-for="(field, index) in currentDangerActive.danger_fields" :key="index">
         
          <b-row v-if="index == activeTab">
            <b-col md="2" sm="12">
              <b-form-group>
                <label>
                  Activo
                </label>
                <br />
                <b-form-radio-group v-model="field.active" buttons :options="[
                  { text: 'SI', value: 1 },
                  { text: 'NO', value: 0 },
                ]" :button-variant="field.active == 1
                ? 'outline-primary'
                : 'outline-secondary'
                " />
              </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
              <b-form-group>
                <label>
                  Requerido
                </label>
                <br />
                <b-form-radio-group v-model="field.required" buttons :options="[
                  { text: 'SI', value: 1 },
                  { text: 'NO', value: 0 },
                ]" :button-variant="field.required == 1
                ? 'outline-primary'
                : 'outline-secondary'
                " />
              </b-form-group>
            </b-col>
            <b-col md="2" sm="12">
              <b-form-group>
                <label>
                  Visible empresa
                </label>
                <br />
                <b-form-radio-group v-model="field.visible_company" buttons :options="[
                  { text: 'SI', value: 1 },
                  { text: 'NO', value: 0 },
                ]" :button-variant="field.visible_company == 1
                ? 'outline-primary'
                : 'outline-secondary'
                " />
              </b-form-group>
            </b-col>
            <b-col md="3" sm="12">
              <b-form-group>
                <label>
                  Tipo de campo
                  <span style="color: red;">
                    (*)
                  </span>
                </label>
                <el-select v-model="field.type">
                  <el-option v-for="item in listControls" :key="item.id" :label="item.label" :value="item.id"></el-option>
                </el-select>
              </b-form-group>
            </b-col>
            <b-col md="3" sm="12" v-if="field.type == 1 || field.type == 3">
              <b-form-group>
                <label>Control de lista</label>
                <span style="color: red;">
                  (*)
                </span>
                <el-select v-model="field.control" filterable remote @change="getListControls(field.control)" clearable
                  no-data-text="No hay datos que coincidan" no-match-text="No hay datos que coincidan"
                  :remote-method="getListControls">
                  <el-option v-for="control in controls" :key="control.id" :label="control.control"
                    :value="control.id"></el-option>
                </el-select>
              </b-form-group>
            </b-col>
            <!-- Botones de acciones -->
            <b-col cols="12" class="pt-4">
              <b-button class="" @click="onHandleSaveChangesDanger(field)" variant="primary">
                <i class="fa fa-edit" />
                Guardar cambios
              </b-button>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
      <div class="d-flex justify-content-between mt-3">
        <b-button
          variant="outline-primary"
          :to="'/cas/crear-parametrizacion/' +currentDangerActive.id +'/' +currentDangerActive.lista +'/' +currentDangerActive.tagline"
        >
          <i class="fa fa-edit fa-lg"></i>
          Editar o agregar nuevo campo
        </b-button>
        <b-button @click="closeModal" variant="light">
          <i class="fa fa-reply fa-lg"></i>
          Cerrar edición
        </b-button>
      </div>
    </div>
  </template>
  <script>
  // Importaciones generales
  import { mapState, mapActions } from 'vuex';
  export default {
    name: "EditDanger",
    props: {
      closeModal: {
        type: Function,
        default: () => { }
      }
    },
    data() {
      return {
        activeTab: 0
      }
    },
    mounted() {
      this.activeTab = 0
    },
    computed: {
      ...mapState('nuevocas', {
        currentDangerActive: 'currentDangerActive',
        listControls: 'listaControles',
        controls: 'controles'
      }),
    },
    methods: {
      ...mapActions('nuevocas', {
        getListControls: 'ListarControles',
        updateDangerField: 'actualizarCampoPeligro'
      }),
      async onHandleSaveChangesDanger(field) {
        await this.updateDangerField(field)
      },
    }
  }
  </script>
  <style scoped>
  @media (min-width: 1000px) and (max-width: 5000px) {
    .b-select-modules {
      display: none !important;
    }
  }
  @media (min-width: 0px) and (max-width: 999px) {
    .b-tabs-sp > :first-child {
      display: none !important;
    }
  }
  </style>